module.exports = __webpack_public_path__ + "static/media/5.b26694f2.jpg";